export default __webpack_public_path__ + "static/media/carpet-repair.a46f76e7.png";